import * as React from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import FormWithSubmit from "../FormWithSubmit";
import DebouncedButton from "../DebouncedButton";
const useStyles = makeStyles(({
  breakpoints,
  typography
}) => ({
  card: {
    boxShadow: "0 1px 6px 0 rgba(0, 0, 0, 0.16)",
    padding: typography.pxToRem(10),
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: typography.pxToRem(200),
    maxWidth: typography.pxToRem(667),
    paddingTop: typography.pxToRem(26),
    paddingBottom: typography.pxToRem(8),
    [breakpoints.down("xs")]: {
      marginTop: typography.pxToRem(150),
      paddingTop: typography.pxToRem(26),
      paddingBottom: typography.pxToRem(8)
    }
  },
  inputRow: {
    width: "100%",
    maxWidth: typography.pxToRem(290),
    marginBottom: typography.pxToRem(30)
  },
  title: {
    marginTop: 0,
    marginBottom: typography.pxToRem(38),
    fontSize: typography.pxToRem(20),
    lineHeight: 0.86,
    letterSpacing: 0.44,
    fontWeight: 400,
    textAlign: "center",
    [breakpoints.down("xs")]: {
      lineHeight: 1.1
    }
  },
  buttonContainer: {
    [breakpoints.down("xs")]: {
      marginTop: typography.pxToRem(30)
    }
  },
  form: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%"
  }
}));

const ReferenceEntryWrapper = ({
  title,
  buttonText,
  onSubmit,
  valid,
  referenceNumberInput,
  postcodeInput
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(Paper, {
    className: styles.card
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(FormWithSubmit, {
    onSubmit: onSubmit,
    className: styles.form
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.title
  }, title)), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: styles.inputRow
  }, referenceNumberInput), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "row",
    className: styles.inputRow,
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 7
  }, postcodeInput), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 4,
    className: styles.buttonContainer
  }, /*#__PURE__*/React.createElement(DebouncedButton, {
    fullWidth: true,
    disabled: !valid,
    type: "submit"
  }, buttonText))))));
};

export default ReferenceEntryWrapper;